import axios from 'axios';

const fetchFeaturedSymptoms = async () => {
    const response = await axios.get(`${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/featured-symptoms`);
    let featuredSymptoms = response.data.map(function(symptom) {
        let mappedSymptom = {};
        mappedSymptom.name = symptom.name;
        mappedSymptom.id = symptom.id;
        mappedSymptom.slug = symptom.slug;
        return mappedSymptom;
    })
    return featuredSymptoms;
};

const fetchPossibleSymptoms = async (selectedSymptoms) => {
    selectedSymptoms = selectedSymptoms.map(function(symptom) {
        return symptom.id;
    });
    const response = await axios({
        method: 'post',
        url: `${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/possible-symptoms`,
        data: {
            symptomIds: selectedSymptoms
        }
    });
    let possibleSymptoms = response.data.map(function(symptom) {
        let mappedSymptom = {};
        mappedSymptom.name = symptom.name;
        mappedSymptom.id = symptom.id;
        mappedSymptom.slug = symptom.slug;
        return mappedSymptom;
    })
    return possibleSymptoms;
}

const searchDrugs = async (term) => {
    const response = await axios.get(`${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/drugs?term=${term}`);
    let foundedDrugs = response.data.map(function(drug) {
        let mappedDrug = {};
        mappedDrug.name = drug.name;
        mappedDrug.id = drug.id;
        mappedDrug.slug = drug.slug;
        return mappedDrug;
    });
    return foundedDrugs;
}

const fetchConditions = async () => {
    const response = await axios.get(`${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/conditions`);
    let conditions = response.data.map(function(condition) {
        let mappedCondition = {};
        mappedCondition.name = condition.name;
        mappedCondition.id = condition.id;
        mappedCondition.slug = condition.slug;
        return mappedCondition;
    });
    return conditions;
}

const fetchTestResults = async (selectedSymptoms, gender) => {
    selectedSymptoms = selectedSymptoms.map(function(symptom) {
        return symptom.id;
    });
    const response = await axios({
        method: 'post',
        url: `${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/conditions-test-result`,
        data: {
            symptomIds: selectedSymptoms,
            gender: gender,
        }
    });

    return response.data;
}

export default {
    fetchFeaturedSymptoms,
    fetchPossibleSymptoms,
    searchDrugs,
    fetchConditions,
    fetchTestResults,
};